import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { PayeeService } from '../../providers/payee.service';
import { Payee_entry } from '../../models/payee_entry';

/* The user's other entries that use the same W9 - a family's several horses share one. When the W9 is corrected,
* the ones ticked here get the corrected W9 too, signed once. Every entry starts ticked except those with a prize
* cheque already issued: those are locked, because the issued cheque keeps the payee it was cut for.
*/
@Component({
  standalone: false,
  selector: 'app-payee-other-entries',
  templateUrl: './payee-other-entries.component.html',
  styleUrls: ['./payee-other-entries.component.css']
})
export class PayeeOtherEntriesComponent implements OnChanges {

  @Input() payee_id: string;
  @Input() exclude_entry_id: string;
  @Input() disabled = false;
  @Output() selectionChange = new EventEmitter<string[]>();

  entries: Payee_entry[] = [];
  selected = new Set<string>();
  loading = false;
  load_error = '';

  constructor(private payeeService: PayeeService) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['payee_id'] || changes['exclude_entry_id']) {
      this.load();
    }
  }

  private load() {
    this.entries = [];
    this.selected.clear();
    this.load_error = '';
    if (!this.payee_id) {
      this.emit();
      return;
    }
    this.loading = true;
    this.payeeService.getOtherEntriesUsingPayee(this.payee_id, this.exclude_entry_id).then(entries => {
      this.entries = entries;
      entries.filter(e => !e.prize_cheque_issued).forEach(e => this.selected.add(e.entry_id));
      this.loading = false;
      this.emit();
    }).catch(() => {
      // Not knowing the other entries is not an error for the entry being corrected - it still saves.
      this.loading = false;
      this.load_error = 'Your other entries using this W9 could not be loaded, so only this entry will be updated.';
      this.emit();
    });
  }

  get lockedCount(): number {
    return this.entries.filter(e => e.prize_cheque_issued).length;
  }

  toggle(entry: Payee_entry, checked: boolean) {
    if (entry.prize_cheque_issued) {
      return;
    }
    if (checked) {
      this.selected.add(entry.entry_id);
    } else {
      this.selected.delete(entry.entry_id);
    }
    this.emit();
  }

  private emit() {
    this.selectionChange.emit([...this.selected]);
  }
}
